module.exports = __webpack_public_path__ + "static/img/12.42a8b46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/12.png
// module id = 0ZSH
// module chunks = 0